import { jsx as _jsx } from "react/jsx-runtime";
import { LeftPanel, LeftPanelCard, LeftPanelCardBody, LeftPanelContainer, } from '../../../editor.style';
import AlphabetList from '../../../../../components/common/AlphabetList';
import { useSelector } from 'react-redux';
const FloorViewportListPanel = ({ isOpen, onBack, onSelect }) => {
    const floorData = useSelector((state) => state?.floors?.getFloor?.response?.data?.content);
    return (_jsx(LeftPanel, { style: {
            width: '320px',
        }, isOpen: isOpen, children: _jsx(LeftPanelContainer, { children: _jsx(LeftPanelCard, { children: _jsx(LeftPanelCardBody, { children: _jsx(AlphabetList, { hideCheckbox: true, searchKey: '', onSelect: (id) => {
                            const data = floorData?.find((it) => it.floorId === id);
                            onSelect?.(data);
                        }, data: (floorData || []).map((it) => ({ name: it.shortName, id: it.floorId })) }) }) }) }) }));
};
export default FloorViewportListPanel;
